module.exports = __webpack_public_path__ + "img/center.5c7e21cd.png";